import moment from "moment"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import TextSettings from "../../components/TextSettings"
import axios from "../../funcs/axios"
function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
class TextSettingsPage extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_render)),
        wishlist_settings_edited: JSON.parse(
            JSON.stringify(this.props.app_edited.wishlist_settings_edited),
        ),
        compare_settings_edited: JSON.parse(
            JSON.stringify(this.props.app_edited.compare_settings_edited),
        ),
        general_settings_edited: JSON.parse(
            JSON.stringify(this.props.app_edited.general_settings_edited),
        ),
        toast: {
            show: false,
            content: "",
            error: false,
        },
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    changeSetting() {
        const { actions } = this.props
        setTimeout(() => {
            actions.changeAppRenderAction("general", this.state.app_settings.general_settings)
        })
    }

    /** Change text setting */
    changeTextSettings(type: String, updateObj: Object) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    general_settings: {
                        ...this.state.app_settings.general_settings,
                        text: {
                            ...this.state.app_settings.general_settings.text,
                            wishlist_settings: {
                                ...this.state.app_settings.general_settings.text.wishlist_settings,
                                ...updateObj,
                            },
                        },
                    },
                },
            })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    general_settings: {
                        ...this.state.app_settings.general_settings,
                        text: {
                            ...this.state.app_settings.general_settings.text,
                            compare_settings: {
                                ...this.state.app_settings.general_settings.text.compare_settings,
                                ...updateObj,
                            },
                        },
                    },
                },
            })
        }
        this.cacheSetting(type, updateObj)
    }

    render() {
        const { general_settings } = this.state.app_settings
        return (
            <div className="text">
                {general_settings.isActiveAT && (
                    <div style={{ marginBottom: "10px" }}>
                        <a
                            target="_blank"
                            rel="noopener"
                            href={`https://${window.parentUrl}/admin/apps/atranslate/languages?_tab=manual-translate&_type=metafield&id=${this.props.metafieldId}&_app=wishlist`}
                        >
                            Auto Translate
                        </a>
                    </div>
                )}

                <TextSettings
                    type="wishlist"
                    settings={general_settings.text.wishlist_settings}
                    changeTextSettings={this.changeTextSettings.bind(this)}
                />
                <TextSettings
                    type="compare"
                    settings={general_settings.text.compare_settings}
                    changeTextSettings={this.changeTextSettings.bind(this)}
                />
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TextSettingsPage)
